<template>
  <el-button type="info" size="mini" icon="el-icon-download" style="margin-right: 10px" @click="downloadExcel">下载</el-button>
</template>

<script>
import ExportJsonExcel from 'js-export-excel'
export default {
  name: 'ExportExcel',
  props: {
    info: []
  },
  data() {
    return {}
  },
  computed: {
    // errorLogs(){
    //   // return this.$store.getters.errorLogs
    //   // this.$store.dispatch('errorLog/clearErrorLog')
    // }
  },
  mounted() {},
  methods: {
    downloadExcel() {
      // this.$http.post
      console.log(this.info, 'info')
      const data = this.info ? this.info : '' // 表格数据
      var option = {}
      const dataTable = []
      if (data) {
        for (const i in data) {
          if (data) {
            const obj = {
              申请时间: data[i].modifyDate,
              申请企业: data[i].companyName,
              申请人名字: data[i].applicantName,
              身份证号: data[i].idCard,
              入职时间: data[i].entryTime,
              工资所属期: data[i].salaryPeriod,
              预支金额: data[i].yuzhiAmount,
              银行账号: data[i].bankCard,
              收款人名字: data[i].name,
              打款银行: data[i].bankName,
              归属公司: data[i].attributionCompany,
              申请电话: data[i].memberPhone,
              当前状态: data[i].yuzhiApplyStatus,
              打款状态: data[i].remitStatus == 0 ? '无' : data[i].remitStatus == 1 ? '待打款' : data[i].remitStatus == 2 ? '已打款' : '取消打款',
              预支类型: data[i].yuzhiType,
              特殊预支证明: data[i].yuzhiImages,
              说明: data[i].shuoming
            }
            dataTable.push(obj)
          }
        }
      }
      option.fileName = '预支申请记录'
      option.datas = [
        {
          sheetData: dataTable,
          sheetName: 'sheet',
          sheetFilter: [
            '申请时间',
            '申请企业',
            '申请人名字',
            '身份证号',
            '入职时间',
            '工资所属期',
            '预支金额',
            '银行账号',
            '收款人名字',
            '打款银行',
            '归属公司',
            '申请电话',
            '当前状态',
            '打款状态',
            '预支类型',
            '特殊预支证明',
            '说明'
          ],
          sheetHeader: [
            '申请时间',
            '申请企业',
            '申请人名字',
            '身份证号',
            '入职时间',
            '工资所属期',
            '预支金额',
            '银行账号',
            '收款人名字',
            '打款银行',
            '归属公司',
            '申请电话',
            '当前状态',
            '打款状态',
            '预支类型',
            '特殊预支证明',
            '说明'
          ],
          columnWidths: ['8', '8', '8', '12', '6', '6', '10', '10', '6', '10', '10', '10', '10', '6', '10', '18', '10']
        }
      ]
      var toExcel = new ExportJsonExcel(option)
      toExcel.saveExcel()
    }
  }
}
</script>

<style scoped></style>
